import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaAddressCard, FaArrowLeft, FaLock, FaUser } from "react-icons/fa";
import { TbNumbers } from "react-icons/tb";
import axios from "axios";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { emptyCart, setUser, updateCartData } from "../../Redux/Actions";
import { Config } from "../../Config";
import Spinner from "../../components/Spinner/Spinner";
import ReCAPTCHA from "react-google-recaptcha";
import LogoImage from "../../assets/images/logo.png";
import "./Login.scss";
import "./Responsive.scss";

const Login = (props) => {
  let prevPath;
  if (props.location.state !== undefined) {
    if (props.location.state.prevPath !== null && props.location.state.prevPath !== undefined) {
      const prvPath = props.location.state.prevPath.split("/")[1];
      // if (prvPath === "products") {
      //   prevPath = "/products";
      // } else
      if (prvPath === "blog") {
        prevPath = "/blog";
      } else if (prvPath === "pages") {
        prevPath = "/pages";
      } else {
        prevPath = props.location.state.prevPath;
      }
    } else {
      prevPath = "/";
    }
  }
  const [loginType, setLoginType] = useState("OTP");
  const [showLogin, setShowLogin] = useState(false);
  const [userName, setUserName] = useState("");
  const [token, setToken] = useState("");
  const [fillName, setFillName] = useState(false);
  const [mobileWidth, setMobileWidth] = useState(false);
  const [showBackToHome, setShowBackToHome] = useState(false);
  const [mobile, setMobile] = useState("");
  const [cities, setCities] = useState([]);
  const [password, setPassword] = useState("");
  const [nationalCode, setNationalCode] = useState("");
  const [chassisNumber, setChassisNumber] = useState("");
  const [provinces, setProvinces] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedProvince, setSelectedProvince] = useState("");
  const [engineNumber, setEngineNumber] = useState("");
  const [citiesLoader, setCitiesLoader] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [address, setAddress] = useState("");
  const [showSpinner, setShowSpinner] = useState(false);
  const [letters, setLetters] = useState([]);
  const [plate, setPlate] = useState({
    firstNum: "",
    letter: "",
    lastNum: "",
    cityNum: "",
  });
  const cart = useSelector((state) => state.cart);

  useEffect(async () => {
    Config.pageUp();
    if (window.screen.width < 768) {
      setMobileWidth(true);
    }
    getLetters();
    await getProvinces();
  }, []);
  const getProvinces = async () => {
    await fetch(`${Config.apiPath}/api/provinces`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
      },
    }).then(async (response) => {
      let resJson = await response.json();
      if (response.status == 200) {
        setProvinces(resJson.data);
      }
    });
  };
  const getLetters = async () => {
    await fetch(`${Config.apiPath}/plateletters`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
      },
    }).then(async (response) => {
      let resJson = await response.json();
      if (response.status == 200) setLetters(resJson.data);
    });
  };
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const mobileHandler = (e) => {
    setMobile(e.target.value);
  };

  const passwordHandler = (e) => {
    setPassword(e.target.value);
  };

  const rememberMeHandler = (e) => {
    setRememberMe(!rememberMe);
  };

  const registerHandler = () => {
    if (Config.checkMobileValidate(mobile)) {
      setShowSpinner(true);
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      user[0]?.token && myHeaders.append("Authorization", `Bearer ${user[0]?.token}`);
      let raw = JSON.stringify({
        PhoneNumber: mobile,
      });
      let requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(Config.apiPath + "/register", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === 200) {
            toast.success(<div>{result.messages}</div>);
            setShowLogin(true);
            setShowSpinner(false);
          } else {
            toast.error(<div>{result.messages}</div>);
            setShowSpinner(false);
            setShowLogin(false);
          }
        })
        .catch((error) => {
          // console.log(error);
          setShowSpinner(false);
        });
    } else {
      toast.error("لطفا شماره موبایل صحیح وارد کنید!");
    }
  };

  const loginHandler = () => {
    if (password !== "") {
      setShowSpinner(true);
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      user[0]?.token && myHeaders.append("Authorization", `Bearer ${user[0]?.token}`);

      let raw = JSON.stringify({
        Username: mobile,
        Password: password,
      });

      let requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(Config.apiPath + "/otpLogin", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === 200) {
            axios
              .get("/account/getUserInfo", {
                headers: {
                  Authorization: "Bearer " + result.data.token,
                },
              })
              .then(async (results) => {
                if (results.data.data.name === null || !results.data.data.name) {
                  setFillName(true);
                  setToken(result.data.token);
                  setShowSpinner(false);
                } else {
                  let now = new Date();
                  let time = now.getTime();
                  time += 3600 * 1000;
                  now.setTime(time);
                  document.cookie = "rememberMe=true;expires=" + now.toUTCString() + ";path=/";
                  toast.success(<div>{result.messages}</div>);
                  // setShowSpinner(false);
                  let userData = {
                    mobile: mobile,
                    token: result.data.token,
                    name: results.data.data.name,
                    nationalCode: results.data.data.nationalCode,
                    engineNumber: results.data.data.engineNumber,
                    chassisNumber: results.data.data.chassisNumber,
                    plateNO1: results.data.data.plateNO1,
                    plateLetter: results.data.data.plateLetter,
                    plateNO2: results.data.data.plateNO2,
                    plateSerial: results.data.data.plateSerial,
                    provinceId: results.data.data.provinceId,
                    cityId: results.data.data.cityId,
                    address: results.data.data.address,
                  };
                  console.log("userData", userData);
                  console.log("prevPath", prevPath);
                  dispatch(setUser(userData));
                  await axios
                    .get("/orders/showorder", {
                      headers: {
                        "Content-type": "application/json",
                        Authorization: "Bearer " + result.data.token,
                      },
                    })
                    .then((result) => {
                      if (result != undefined) {
                        if (result.status === 200) {
                          console.log("cartOrderDetails", result.data.orderDetail);
                          let cartOrderDetails;
                          if (!result.data.orderDetail) {
                            cartOrderDetails = result.data.data.orderDetail;
                          } else {
                            cartOrderDetails = result.data.orderDetail;
                          }
                          let obj = [];
                          cartOrderDetails.map((item) => {
                            obj.push({
                              id: item.productId,
                              productImage: item.image,
                              providerId: item.providerId,
                              description: "",
                              productName: item.title,
                              isApproved: item.isApproved,
                              unitPrice: item.price,
                              weight: "",
                              pageCount: "",
                              orderDetailId: item.orderDetailId,
                              count: item.count,
                            });
                          });
                          console.log("1", result);
                          dispatch(updateCartData(obj));
                          setShowSpinner(false);
                          props.history.push({
                            pathname: prevPath && prevPath !== undefined ? prevPath : "/",
                          });
                        } else {
                          dispatch(emptyCart(cart));
                          setShowSpinner(false);
                          props.history.push({
                            pathname: prevPath && prevPath !== undefined ? prevPath : "/",
                          });
                        }
                      } else {
                        dispatch(emptyCart(cart));
                        setShowSpinner(false);
                        props.history.push({
                          pathname: prevPath && prevPath !== undefined ? prevPath : "/",
                        });
                        return false;
                      }
                    });
                }
              });
          } else {
            toast.error(<div>{result.messages}</div>);
            setShowSpinner(false);
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    } else {
      toast.error("رمز پیامکی وارد نشده است!");
    }
  };

  const simpleLoginHandler = () => {
    if (loginType === "STATIC") {
      setLoginType("OTP");
      setPassword("");
    } else {
      setLoginType("STATIC");
      setPassword("");
    }
  };

  const recaptchHandler = (e) => {
    // console.log(e);
  };

  const staticLoginHandler = () => {
    setShowSpinner(true);
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    user[0]?.token && myHeaders.append("Authorization", `Bearer ${user[0]?.token}`);
    let raw = JSON.stringify({
      Username: mobile,
      Password: password,
    });

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(Config.apiPath + "/Login", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === 200) {
          axios
            .get("/account/getUserInfo", {
              headers: {
                Authorization: "Bearer " + result.data.token,
              },
            })
            .then((results) => {
              if (results.data.data.name !== null) {
                let user = {
                  mobile: mobile,
                  token: result.data.token,
                  name: results.data.data.name,
                };
                dispatch(setUser(user));
                props.history.push({
                  pathname: prevPath && prevPath !== undefined ? prevPath : "/",
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
          toast.success(<div>{result.messages}</div>);
          setShowSpinner(false);
          if (rememberMe) {
            let now = new Date();
            let time = now.getTime();
            time += 3600 * 1000;
            now.setTime(time);
            document.cookie = "rememberMe=true;expires=" + now.toUTCString() + ";path=/";
          } else {
            document.cookie = "rememberMe=false;path=/";
          }
        } else {
          toast.error(<div>{result.messages}</div>);
          setShowSpinner(false);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const editMobileHandler = () => {
    setShowLogin(false);
  };

  const registerNameHandler = () => {
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);

    let raw = JSON.stringify({
      fullName: userName,
      nationalCode: nationalCode,
      chassisNumber: chassisNumber,
      engineNumber: engineNumber,
      plateNO1: parseInt(plate.firstNum),
      plateLetter: plate.letter,
      plateNO2: parseInt(plate.lastNum),
      plateSerial: parseInt(plate.cityNum),
      provinceId: getIdHandler(selectedProvince) || null,
      cityId: selectedCity || null,
      address: address || null,
    });

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    if (
      !userName ||
      plate.cityNum.length < 2 ||
      plate.lastNum.length < 3 ||
      !plate.letter ||
      plate.firstNum.length < 2 ||
      nationalCode.length < 10 ||
      !selectedProvince ||
      !selectedCity ||
      !address
    ) {
      toast.error("لطفا همه ی اطلاعات اجباری را به درستی وارد کنید");
      return;
    }
    if (nationalCode.length < 10) {
      toast.error("کد ملی باید بیشتر از 9 عدد باشد");
      return;
    }
    if (plate.cityNum.length < 2 || plate.lastNum.length < 3 || !plate.letter || plate.firstNum.length < 2) {
      toast.error("لطفا پلاک را به درستی وارد نمایید");
      return;
    }
    // if (plate.cityNum || plate.lastNum || plate.letter || plate.firstNum) {
    // }
    //   toast.error("شماره شاسی ناوگان را وارد کنید");
    //   return;
    // } else if (!engineNumber) {
    //   toast.error("شماره موتور را وارد نمایید");
    //   return;
    // }
    setShowSpinner(true);

    fetch(Config.apiPath + "/account/changeUserInfo", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === 200) {
          let now = new Date();
          let time = now.getTime();
          time += 3600 * 1000;
          now.setTime(time);
          document.cookie = "rememberMe=true;expires=" + now.toUTCString() + ";path=/";
          toast.success(<div>{result.messages}</div>);
          setShowSpinner(false);
          let user = {
            mobile: mobile,
            token: token,
            name: userName,
            nationalCode: nationalCode,
            chassisNumber: chassisNumber,
            engineNumber: engineNumber,
            plateNO1: plate.firstNum,
            plateLetter: plate.letter,
            plateNO2: plate.lastNum,
            plateSerial: plate.cityNum,
            provinceId: getIdHandler(selectedProvince) || null,
            cityId: selectedCity || null,
            address: address || null,
          };
          dispatch(setUser(user));
          props.history.push({
            pathname: prevPath && prevPath !== undefined ? prevPath : "/",
          });
        } else {
          toast.error(<div>{result.messages}</div>);
          setShowSpinner(false);
        }
      })
      .catch((error) => {
        // console.log(error);
        setShowSpinner(false);
      });
  };

  const userNameHandler = (e) => {
    setUserName(e.target.value);
  };

  const getIdHandler = (id) => {
    let found = id ? provinces.filter((i) => i.nstwProvinceId == id) : [];
    if (found.length > 0) {
      return found[0].id;
    } else {
      return "";
    }
  };

  const setProvinceHandler = async (e) => {
    setSelectedProvince(e.target.value);
    setSelectedCity("");
    setCitiesLoader(true);
    await getCities(e.target.value);
  };

  const getCities = async (id, isDef) => {
    await fetch(`${Config.apiPath}/api/cities/getCityWithFilter/${id}`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
      },
    }).then(async (response) => {
      let resJson = await response.json();
      if (response.status == 200) {
        setCities(resJson.data);
        setCitiesLoader(false);
      }
      setCitiesLoader(false);
    });
  };

  const fullNameKeyDown = (e) => {
    var keyCode = e.which || e.keyCode;
    if (keyCode === 13) {
      registerNameHandler();
    }
  };

  const passwordKeyDown = (e) => {
    var keyCode = e.which || e.keyCode;
    if (keyCode === 13) {
      loginHandler();
    }
  };

  const mobileKeyDown = (e) => {
    var keyCode = e.which || e.keyCode;
    if (keyCode === 13) {
      registerHandler();
    }
  };

  const staticPasswordKeyDown = (e) => {
    var keyCode = e.which || e.keyCode;
    if (keyCode === 13) {
      staticLoginHandler();
    }
  };

  const goBackHandler = () => {
    props.history.push("/");
  };

  const showBackToHomeToggler = (type) => {
    if (mobileWidth) {
      setShowBackToHome(type);
    }
  };

  const plateChangeHandler = (type, e) => {
    let pattern = /^[0-9]+$/;
    if (type === "firstNum") {
      setPlate({ ...plate, firstNum: e.target.value });
      if (e.target.value && !pattern.test(e.target.value)) {
        setPlate({ ...plate, firstNum: "" });
      }
    } else if (type === "lastNum") {
      setPlate({ ...plate, lastNum: e.target.value });
      if (e.target.value && !pattern.test(e.target.value)) {
        setPlate({ ...plate, lastNum: "" });
      }
    } else if (type === "letter") {
      setPlate({ ...plate, letter: e.target.value });
    } else if (type === "cityNum") {
      setPlate({ ...plate, cityNum: e.target.value });
      if (e.target.value && !pattern.test(e.target.value)) {
        setPlate({ ...plate, cityNum: "" });
      }
    }
  };

  if (loginType === "OTP") {
    return (
      <section className="loginWrapper">
        <Helmet>
          <title>{Config.helmetTitle} | ورود به حساب کاربری</title>
          <meta name="description" content="Helmet application" />
        </Helmet>
        <div className="rightSide">
          <div className="logo">
            <Link to="/">
              <img src={LogoImage} alt="logo" />
            </Link>
            <p className="pageTitle">ورود به حساب کاربری با پیامک</p>
          </div>
          <div className="formWrapper">
            {!showLogin ? (
              <React.Fragment>
                <div className="formGroup">
                  <div className="caption">
                    <input
                      type="text"
                      value={mobile}
                      onChange={(e) => mobileHandler(e)}
                      onKeyPress={mobileKeyDown}
                      onFocus={() => {
                        showBackToHomeToggler(true);
                      }}
                      onBlur={() => {
                        showBackToHomeToggler(false);
                      }}
                      id="mobile"
                      placeholder=""
                    />
                    <span className="placeholder">شماره موبایل</span>
                    <FaUser className="loginInputIcon" />
                  </div>
                </div>
                <div className="formGroup">
                  <button className="btnLogin" onClick={registerHandler}>
                    {showSpinner ? <Spinner color="#fff" /> : "ارسال"}
                  </button>
                </div>
              </React.Fragment>
            ) : (
              <React.Fragment>
                {!fillName ? (
                  <React.Fragment>
                    <div className="formGroup">
                      <div className="caption">
                        <input
                          type="password"
                          value={password}
                          onChange={(e) => passwordHandler(e)}
                          onKeyPress={passwordKeyDown}
                          onFocus={() => {
                            showBackToHomeToggler(true);
                          }}
                          onBlur={() => {
                            showBackToHomeToggler(false);
                          }}
                          id="password"
                          placeholder=""
                        />
                        <span className="placeholder">رمز عبور</span>
                        <FaLock className="loginInputIcon" />
                      </div>
                    </div>
                    <div className="formGroup">
                      <button className="btnLogin" onClick={loginHandler}>
                        {showSpinner ? <Spinner color="#fff" /> : "ارسال"}
                      </button>
                    </div>
                    <div className="formGroup">
                      <p className="loginType" onClick={editMobileHandler}>
                        <FaArrowLeft className="loginTypeIcon" /> ویرایش شماره
                      </p>
                    </div>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <div className="formGroup">
                      <div className="caption">
                        <input
                          type="text"
                          value={userName}
                          onChange={(e) => userNameHandler(e)}
                          onKeyPress={fullNameKeyDown}
                          id="userName"
                          placeholder=""
                        />
                        <p className="placeholder">
                          نام و نام خانوادگی <span className="require">( اجباری )</span>
                        </p>
                        <FaUser className="loginInputIcon" />
                      </div>
                    </div>
                    <div className="formGroup">
                      <div className="caption">
                        <input
                          type="text"
                          value={nationalCode}
                          onChange={(e) => setNationalCode(e.target.value)}
                          onKeyPress={fullNameKeyDown}
                          id="nationalCode"
                          placeholder=""
                        />
                        <p className="placeholder">
                          کد ملی <span className="require">( اجباری )</span>
                        </p>
                        <FaUser className="loginInputIcon" />
                      </div>
                    </div>
                    <div className="formGroup">
                      <div className="caption">
                        <input
                          type="text"
                          value={engineNumber}
                          onChange={(e) => setEngineNumber(e.target.value)}
                          onKeyPress={fullNameKeyDown}
                          id="engineNumber"
                          placeholder=""
                        />
                        <p className="placeholder">شماره موتور ( اختیاری )</p>
                        <TbNumbers className="loginInputIcon" />
                      </div>
                    </div>
                    <div className="formGroup">
                      <div className="caption">
                        <input
                          type="text"
                          value={chassisNumber}
                          onChange={(e) => setChassisNumber(e.target.value)}
                          onKeyPress={fullNameKeyDown}
                          id="chassisNumber"
                          placeholder=""
                        />
                        <p className="placeholder">شماره شاسی ناوگان ( اختیاری )</p>
                        <TbNumbers className="loginInputIcon" />
                      </div>
                    </div>
                    <div className="formGroup">
                      <div className="caption">
                        <div className="inputWrapper">
                          <input
                            type="text"
                            onChange={(e) => plateChangeHandler("cityNum", e)}
                            maxLength={2}
                            placeholder="11"
                            pattern="/[0-9]/gm"
                            className="tag lastNum"
                            value={plate.cityNum}
                          />
                          <input
                            type="text"
                            value={plate.lastNum}
                            maxLength={3}
                            placeholder="- - -"
                            onChange={(e) => plateChangeHandler("lastNum", e)}
                            className="tag num"
                          />
                          <select className="tag" onInput={(e) => plateChangeHandler("letter", e)}>
                            <option disabled selected>
                              x
                            </option>
                            {letters.map((i, index) => {
                              return <option value={i}>{i}</option>;
                            })}
                          </select>
                          <input
                            type="text"
                            maxLength={2}
                            placeholder="- -"
                            onChange={(e) => plateChangeHandler("firstNum", e)}
                            className="tag num"
                            value={plate.firstNum}
                          />
                        </div>
                        <p className="placeholder">
                          شماره پلاک <span className="require">( اجباری )</span>
                        </p>
                        {/* <TbNumbers className="loginInputIcon" /> */}
                      </div>
                    </div>
                    <div className="formGroup">
                      <div className="caption">
                        <div className="inputWrapper">
                          <select className="tag full" value={selectedProvince} onInput={(e) => setProvinceHandler(e)}>
                            <option disabled selected value="">
                              لطفا انتخاب کنید
                            </option>
                            {provinces.map((i, index) => {
                              return (
                                <option className="letterOption" value={i.nstwProvinceId} key={index}>
                                  {i.name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                        <p className="placeholder">
                          استان <span className="require">( اجباری )</span>
                        </p>
                        {/* <TbNumbers className="loginInputIcon" /> */}
                      </div>
                    </div>
                    <div className="formGroup">
                      <div className="caption">
                        <div className="inputWrapper">
                          <select
                            className="tag full"
                            value={selectedCity}
                            onInput={(e) => setSelectedCity(e.target.value)}
                          >
                            <option disabled selected value="">
                              {cities.length < 1
                                ? "لطفا ابتدا استان را انتخاب کنید"
                                : citiesLoader
                                ? "لطفا صبر کنید"
                                : "انتخاب کنید"}
                            </option>
                            {cities.map((i, index) => {
                              return (
                                <option className="letterOption" value={i.id} key={index}>
                                  {i.name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                        <p className="placeholder">
                          شهر <span className="require">( اجباری )</span>
                        </p>
                        {/* <TbNumbers className="loginInputIcon" /> */}
                      </div>
                    </div>
                    <div className="formGroup">
                      <div className="caption">
                        <input
                          type="text"
                          value={address}
                          onChange={(e) => setAddress(e.target.value)}
                          id="address"
                          placeholder=""
                        />
                        <p className="placeholder">
                          آدرس <span className="require">( اجباری )</span>
                        </p>
                        <FaAddressCard className="loginInputIcon" />
                      </div>
                    </div>
                    <div className="formGroup">
                      <button className="btnLogin" onClick={registerNameHandler}>
                        {showSpinner ? <Spinner color="#fff" /> : "ارسال"}
                      </button>
                    </div>
                  </React.Fragment>
                )}
              </React.Fragment>
            )}
          </div>
        </div>
        <div className="leftSide"></div>
      </section>
    );
  } else if (loginType === "STATIC") {
    return (
      <section className="loginWrapper">
        <Helmet>
          <title>ورود به حساب کاربری</title>
          <meta name="description" content="Helmet application" />
        </Helmet>
        <div className="rightSide">
          {/* {!showBackToHome && (
            <span className="goBack" onClick={goBackHandler}>
              <FaArrowLeft />
              &nbsp;صفحه اصلی
            </span>
          )} */}
          <div className="logo">
            <Link to="/">
              <img src={LogoImage} alt="logo" />
            </Link>
            <p className="pageTitle">ورود به حساب کاربری با رمز ثابت</p>
          </div>
          <div className="formWrapper">
            <div className="formGroup">
              <div className="caption">
                <input
                  type="text"
                  value={mobile}
                  onChange={(e) => mobileHandler(e)}
                  id="mobile"
                  placeholder=""
                  onFocus={() => {
                    showBackToHomeToggler(true);
                  }}
                  onBlur={() => {
                    showBackToHomeToggler(false);
                  }}
                />
                <span className="placeholder">شماره موبایل</span>
                <FaUser className="loginInputIcon" />
              </div>
            </div>
            <div className="formGroup">
              <div className="caption">
                <input
                  type="password"
                  value={password}
                  onChange={(e) => passwordHandler(e)}
                  onKeyPress={staticPasswordKeyDown}
                  onFocus={() => {
                    showBackToHomeToggler(true);
                  }}
                  onBlur={() => {
                    showBackToHomeToggler(false);
                  }}
                  id="password"
                  placeholder=""
                />
                <span className="placeholder">رمز عبور</span>
                <FaLock className="loginInputIcon" />
              </div>
            </div>

            <div className="formGroup">
              <label className="checkbox">
                مرا به خاطر بسپار
                <input type="checkbox" value={rememberMe} onChange={(e) => rememberMeHandler(e)} />
                <span className="checkboxmark"></span>
              </label>
            </div>
            <div className="formGroup">
              <p>
                رمز عبور خود را فراموش کرده اید؟
                <Link to="/changePasswordByCode" className="link">
                  بازیابی رمز عبور
                </Link>
              </p>
            </div>
            <div className="formGroup">
              <ReCAPTCHA
                size="invisible"
                sitekey="6LfO7RAlAAAAAMcpWRyrmUNJYqmrl64Dp-h9u4Qt"
                onChange={recaptchHandler}
              />
              {/* <ReCAPTCHA size="invisible" sitekey="6Lfgov0bAAAAAFGd8c6ALNbuFDyrElRKdUukingY" onChange={recaptchHandler} /> */}
            </div>
            <div className="formGroup">
              <button className="btnLogin" onClick={staticLoginHandler}>
                {showSpinner ? <Spinner color="#fff" /> : "ورود"}
              </button>
            </div>
            <div className="formGroup">
              <p className="loginType" onClick={simpleLoginHandler}>
                <FaArrowLeft className="loginTypeIcon" /> ورود با پیامک
              </p>
            </div>
          </div>
        </div>
        <div className="leftSide"></div>
      </section>
    );
  }
};

export default React.memo(Login);
